import ApiService from '@/services/core/api.service'

const PositionService = {
  async get (query) {
    return ApiService.get(`admin/positions?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/positions', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/positions/${payload.id}`, payload)
  }
}

export default PositionService
